export default "__VITE_ASSET__289b99b5__"